import {
  IAdsConfiguration,
  IAppnexusOutstreamPlayerConfiguration,
} from "@almamedia/amr-adtech-stack/lib/services/ads/adsservice";
import { thirdPartyCookiesEnabled } from "@almamedia/amr-adtech-stack/lib/shared/cookiecheck/cookie-check";
import { ICustomVariables } from "../data-layer/data-layer";
import { SiteNativeTemplate } from "../native/native";
import adTargeting from "./targeting";
import placements from "./placements";

const ads: IAdsConfiguration<ICustomVariables, SiteNativeTemplate> = {
  enabled: true,
  placements,
  targeting: adTargeting,
  defaults: {
    astJs: {
      disablePsa: true,
      allowSmallerSizes: false,
      allowedFormats: ["banner"],
      nobidIfUnsold: false,
    },
    memberId: 6931,
    autoInit: false,
    contextual: {
      relevancyLimits: {
        iabTier1: {
          min: 0,
          max: 100,
        },
        iabTier2: {
          min: 10,
          max: 100,
        },
        semantics: {
          min: 10,
          max: 100,
        },
      },
    },
    geoOptions: {
      enabled: true,
      timeout: 200,
    },
    publisherId: {
      usePublisherId: async () => !thirdPartyCookiesEnabled(500),
    },
  },
  outstream: {
    rendererOptions: {
      autoInitialSize: false,
      alignment: "left",
      playOnMouseover: false,
      audioOnMouseover: true,
      playVideoVisibleThreshold: 50,
      expandTime: 1000,
      adText: "ILMOITUS",
      showMute: true,
      showVolume: false,
      showProgressBar: true,
      allowFullscreen: true,
      vpaidTimeout: 5000,
      terminateUnresponsiveVPAIDCreative: false,
      enableInlineVideoForIos: true,
      disableCollapse: {
        enabled: true,
      },
      aspectRatio: "16:9",
      delayExpandUntilVPAIDInit: true,
      delayExpandUntilVPAIDImpression: false,
      disableTopBar: false,
      controlBarPosition: "over",
      nonViewableBehavior: "pause",
      skippable: {
        enabled: false,
      },
      playerSkin: {
        topBarColor: "#FFFFFF",
      },
    },
    preRequest: (
      config: IAppnexusOutstreamPlayerConfiguration
    ): IAppnexusOutstreamPlayerConfiguration => {
      return {
        ...config,
        allowFullscreen:
          !navigator.userAgent.match(/(iPod|iPhone|iPad)/) ||
          !navigator.userAgent.match(/AppleWebKit/),
      };
    },
  },
  roadblocks: [
    {
      primary: "almad-parade-1",
      secondaries: ["almad-wallpaper-1", "almad-skyscraper-1"],
      sections: [
        "uutiset_desktop_wide",
        "uutiset_artikkeli_desktop_wide",
        "yritykset_desktop_wide",
        "kaupallinen_yhteistyo_desktop_wide",
      ],
    },
  ],
};

export default ads;
